export const SEARCH_QUERY_CLASS_NAME = 'search-query';
